var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F05138;}\r\n\t.st1{fill:#FEFEFE;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.7,32.5c0-1.1-0.1-2.3-0.4-3.3c-0.4-2.3-1.6-4.3-3.3-5.9c-0.9-0.8-1.9-1.5-2.9-2s-2.3-0.9-3.5-1.1 C81.4,20,80,20,79,20H50c-0.9,0-1.9,0.1-2.7,0.3c-0.9,0.1-1.7,0.3-2.7,0.7l-0.8,0.4c-0.8,0.4-1.6,0.8-2.3,1.3 c-0.3,0.3-0.5,0.3-0.7,0.5c-0.9,0.8-1.6,1.6-2.1,2.7c-0.5,0.9-0.9,2.1-1.2,3.2c-0.1,1.1-0.3,2.1-0.4,3.3v25.3c0,1.1,0.1,2.3,0.4,3.3 c0.4,2.3,1.6,4.3,3.3,5.9c0.8,0.8,1.9,1.5,2.9,1.9c1.1,0.5,2.3,0.9,3.5,1.1c1.2,0.3,2.5,0.3,3.6,0.3h28.2c1.2,0,2.4-0.1,3.6-0.3 c1.2-0.1,2.3-0.5,3.3-1.1s2.1-1.2,3.1-1.9c0.9-0.8,1.6-1.6,2.1-2.7c0.5-0.9,0.9-2.1,1.2-3.2c0.1-1.1,0.3-2.1,0.4-3.3L92.7,32.5 L92.7,32.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.3,58.7c-4.9,2.5-11.7,2.8-18.6,0.3c-5.3-2-9.8-5.6-13-10.1c1.5,1.1,3.1,2,4.8,2.7c7,2.9,14.1,2.8,19,0 C59.9,46.7,54,41.3,48.9,35.2c-0.9-0.9-1.7-1.9-2.4-2.9c5.3,4.3,11,8.1,17,11.6c-4.4-4.3-8.4-8.8-12-13.6 c6.1,5.6,12.6,10.4,19.8,14.6l0.8,0.4c0.3-0.5,0.4-0.9,0.5-1.5c1.6-5.5-0.3-11.6-4.4-16.6c9.6,5.2,15.2,14.9,12.8,23.1 c0,0.3-0.1,0.4-0.1,0.7l0.1,0.1c4.7,5.3,3.5,10.9,2.8,9.8C81.5,56.3,76.7,57.8,74.3,58.7L74.3,58.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/Swift.cf6e545de61aa9b79eb692da862044b0.svg";
export { ForwardRef as ReactComponent };